import { useEffect, useState } from "react";
import AreaChart from "../../../components/AreaCharts";
import * as CustomToast from "../../../components/CustomToastMessage";
import axiosInstance from "../../../utils/axiosConfig";
import { Dropdown, Form } from "react-bootstrap";
import MultipleSelectDropdown from "../../../components/MultipleSelectDropdown";
import { generateYearOptions } from "../../../helper";

const NewUserChart = () => {
    const [newUsersData, setNewUsersData] = useState({ value: [], label: [] });
    const yearOptions = generateYearOptions(2);
    const [selectedYear, setSelectedYear] = useState(yearOptions[0]);

    const getNewUsersData = async (year = "") => {
        try {
            const response = await axiosInstance.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/admin/dashboard/new/users?year=${year}`
            );
            if (response.data.success) {
                const { monthlyNewUsers } = response.data.data;
                const value = (monthlyNewUsers || []).map((item) => Number(item.count) || 0);
                const label = (monthlyNewUsers || []).map((item) => item.monthName);
                setNewUsersData({ value, label });
            }
        } catch (error) {
            CustomToast.error(
                error.response?.data?.message || "Error fetching new users data"
            );
        }
    };

    useEffect(() => {
        const year = new Date().getFullYear();
        getNewUsersData(year);
    }, []);

    const handleChangeYear = (year) => {
        setSelectedYear(year);
        getNewUsersData(year.value);
    };
    return (
        <>
            <div className="card page-card mt-4 area-chart-custom rounded-4">
                <div className="card-header mx-0 px-4 rounded-top-4">
                    <div className="d-flex flex-wrap flex-md-nowrap gap-2 justify-content-between align-items-center">
                        <h5>Monthly User Acquisition</h5>
                        <Form.Group controlId="categories">
                            <MultipleSelectDropdown
                                options={
                                    yearOptions?.map((item) => ({
                                        value: item.value,
                                        label: item.label,
                                    })) || []
                                }
                                value={selectedYear}
                                name="year"
                                id="year"
                                className="p-0"
                                placeholder="Year"
                                isSearchable
                                onChange={handleChangeYear}
                            />
                        </Form.Group>
                    </div>
                </div>
                <div className="card-body">
                    <AreaChart data={newUsersData} />
                </div>
            </div>
        </>
    )
}

export default NewUserChart;